import { useRouter } from 'next/router';

import Layout from '@/components/Layout';
import { useMatchMedia } from '@/hooks/useMatchMedia';

import { ContactBox } from '../central-de-ajuda/components/ContactBox';
import { SearchBar } from '../central-de-ajuda/components/SearchBar';
import { CentralDeAjudaDataItem } from '../central-de-ajuda/data';
import * as S from './styles';

interface TemplateCentralDeAjudaInternaProps {
  pageData: CentralDeAjudaDataItem;
}

const pagesLinkList = [
  {
    title: 'Realização do evento',
    id: 'tenho-uma-duvida-sobre-a-realizacao-do-evento',
  },
  {
    title: 'Cancelamento de Pedido',
    id: 'como-solicitar-o-cancelamento-do-meu-pedido',
  },
  {
    title: 'Alterar setor do ingresso',
    id: 'gostaria-de-alterar-o-setor-do-meu-ingresso',
  },
  {
    title: 'Me arrependi de um cancelamento que solicitei',
    id: 'me-arrependi-de-um-cancelamento-que-solicitei',
  },
  {
    title: 'Troca de Titularidade',
    id: 'troca-de-titularidade',
  },
  {
    title: 'Como ter acesso a meus ingressos?',
    id: 'como-ter-acesso-a-meus-ingressos',
  },
  {
    title: 'Compra não aprovada/cancelada',
    id: 'compra-nao-aprovada-cancelada',
  },
  {
    title: 'Cortesia eletrônica',
    id: 'nao-consigo-acessar-cortesia-eletronica',
  },
];

export const TemplateCentralDeAjudaInterna: React.FC<TemplateCentralDeAjudaInternaProps> =
  ({ pageData }) => {
    const isScreenLessThan640 = useMatchMedia('(max-width: 640px)');

    const router = useRouter();
    const pageId = router.asPath.split('/')?.[2];

    return (
      <Layout>
        <S.Container>
          <S.Wrapper>
            <S.SideNav>
              <div>
                <SearchBar sidebarVersion />

                {!isScreenLessThan640 && (
                  <S.Contact>
                    <p>Não encontrou sua dúvida aqui?</p>
                    <span>
                      Entre em contato através do e-mail:
                      contato@boratickets.com.br
                    </span>
                  </S.Contact>
                )}
              </div>

              {!isScreenLessThan640 && (
                <S.LinksContainer>
                  {pagesLinkList.map(item => (
                    <a
                      key={item.id}
                      href={`/central-de-ajuda/${item.id}`}
                      className={item.id === pageId ? 'selected' : ''}
                    >
                      {item.title}
                    </a>
                  ))}
                </S.LinksContainer>
              )}
            </S.SideNav>

            <S.ContentContainer>
              <h1>{pageData.title}</h1>

              <S.Content dangerouslySetInnerHTML={{ __html: pageData.data }} />

              {isScreenLessThan640 && (
                <div style={{ marginTop: '6rem' }}>
                  <ContactBox />
                </div>
              )}
            </S.ContentContainer>
          </S.Wrapper>
        </S.Container>
      </Layout>
    );
  };
